import { FieldValues, Path, useFormContext } from "react-hook-form";
import { Sidebar } from "primereact/sidebar";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { DropdownFilterEvent } from "primereact/dropdown";

import DropdownControl from "@shared/ui/hook-form/dropdown-control/dropdown-control";
import { useFormDropdownSalaryTypeContext } from "./form-dropdown-salary-type.context";

export interface FormDropdownSalaryTypeProps<T extends FieldValues> {
  name: Path<T>;
  allowCreate?: boolean;
}

export function FormDropdownSalaryType<T extends FieldValues>({
  name,
  allowCreate = false,
}: FormDropdownSalaryTypeProps<T>) {
  const hintText = allowCreate
    ? `Select from the created holidayType dropdown. Otherwise, hit ENTER to create a new holidayType. If the holidayType doesn't exist select N/A`
    : "";
  const { control } = useFormContext<T>();
  const {
    sidebar,
    newSalaryType,
    mappedSalaryType,
    isCreating,
    setSidebar,
    setFilter,
    setNewSalaryType,
    handleFilterInput,
    handleAdd,
  } = useFormDropdownSalaryTypeContext();
  
  return (
    <div className="salary-type">
      {newSalaryType && (
        <Sidebar visible={sidebar} onHide={() => setSidebar(false)}>
          <h2>Create new salaryType</h2>
          <p>
            You are creating a new salaryType. Please, fill the fields to create a
            new salaryType and apply to current item creation.
          </p>
          <div className="flex flex-col gap-2 mt-4">
            <InputText
              placeholder="SalaryType Name"
              value={newSalaryType.name}
              onChange={(e: any) =>
                setNewSalaryType({ ...newSalaryType, name: e.target.value })
              }
            />
            <InputText
              placeholder="SalaryType Description"
              value={newSalaryType.description}
              onChange={(e: any) =>
                setNewSalaryType({ ...newSalaryType, description: e.target.value })
              }
            />

            <Button
              label="Create"
              onClick={handleAdd}
              className="block"
              disabled={isCreating}
            />
          </div>
        </Sidebar>
      )}
      <DropdownControl<T>
        control={control}
        name={name}
        label="SalaryType"
        options={ mappedSalaryType }
        containerClassName="mb-9"
        className="w-full md:w-3/4"
        placeholder="Enter your salaryType"
        hint={hintText}
        filter
        onFilter={(e: DropdownFilterEvent) => setFilter(e.filter)}
        onKeyDown={allowCreate ? handleFilterInput : () => {}}
      />
    </div>
  );
}

export default FormDropdownSalaryType;